// extracted by mini-css-extract-plugin
module.exports = {"container":"SideNavigation_container__2CnZr","content":"SideNavigation_content__SBvJe","item":"SideNavigation_item__7G70P","active":"SideNavigation_active__2BRyS"};